import InsertPageModal from './InsertPageModalContainer';

export default InsertPageModal;